import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/terms-of-service")({ beforeLoad: redirectTo("/terms") });
